import React, { createContext, useContext, useEffect, useState } from 'react';
import { useCreateList } from './hooks/useLists';
import { SCREENS } from './AddToConstants';

const funcDefault = () => {
  // This is intentional
};

export const AddToContext = createContext({
  listDetails: {},
  projectRefetch: funcDefault,
  listRefetch: funcDefault,
  handleBackPress: funcDefault,
  setScreen: funcDefault,
  selectedProductDetails: {},
  setSelectedProductDetails: funcDefault,
  setShowSuccessMessage: funcDefault,
  addSelectedTo: funcDefault,
  addToType: '',
  products: []
});

export const AddToClear = () => {
  const { screen, successMessage, setSuccessMessage } = useContext(AddToContext);

  useEffect(() => {
    if (successMessage?.length > 0 && screen !== SCREENS.DEFAULT) {
      setSuccessMessage('');
    }
  }, [screen]);
  return null;
};

export const AddToProvider = ({ children, value }) => {
  const [successMessage, setSuccessMessage] = useState('');
  const [abandonWarning, setAbandonWarning] = useState({ show: false, action: 'CLOSE' });
  const [canShowWarning, setCanShowWarning] = useState(false);

  useEffect(() => {
    return () => {
      setSuccessMessage('');
    };
  }, []);

  return (
    <AddToContext.Provider value={{
      ...value,
      successMessage,
      setSuccessMessage,
      abandonWarning,
      setAbandonWarning,
      canShowWarning,
      setCanShowWarning
    }}
    >
      {children}
      <AddToClear />
    </AddToContext.Provider>
  );
};
